import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import UserDropdown from '../UserDropdown/UserDropdown';

const ClientLayout = ({ children }) => {
  const { tenantDomain } = useParams();
  const { updateTenantDomain } = useAuth();

  useEffect(() => {
    updateTenantDomain(tenantDomain);
  }, [tenantDomain]);

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <header className="h-14 border-b bg-background flex items-center justify-between px-4 shrink-0 sticky top-0 z-10">
        <span className="font-semibold text-base tracking-tight">Trainamic</span>
        <UserDropdown />
      </header>
      <main className="flex-1 flex flex-col overflow-hidden">
        {children}
      </main>
    </div>
  );
};

export default ClientLayout;
